<template>

  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-lg-8 mx-auto">
        <div class="card my-5">
          <div class="card-header p-3 pb-0">
            <div class="d-flex justify-content-between align-items-center">
              
              <div>
                <button @click="$router.back()">X</button>
                <h6>Detalhes do Pedido</h6>
                <p class="text-sm mb-0">
                  Pedido #
                  <b>{{ pedido.numero_pedido }}</b> de
                  <b>{{ fDate(pedido.data_criacao) }}</b>
                </p>
                <p class="text-sm">
                  Id:
                  <b>{{ pedido.id_pedido }}</b>
                </p>
              </div>
              <argon-button
                color="secondary"
                variant="gradient"
                class="ms-auto mb-0"
                @click="imprimirPagina()"
                >Imprimir</argon-button
              >
            </div>
          </div>
          <div class="card-body p-3 pt-0">
            <hr class="horizontal dark mt-0 mb-4" />
            
            <div class="row">
              
              <div class="col-lg-3 col-md-6 col-12">
                <h6 class="mb-3">Movimentações</h6>
                <div class="timeline timeline-one-side">
                  <div class="timeline-block mb-3" v-for="movimento in getMovimentacoes">
                    <span class="timeline-step">
                      <i :class="`${movimento.icone} text-secondary`"></i>
                    </span>
                    <div class="timeline-content">
                      <h6 class="text-dark text-sm font-weight-bold mb-0">
                        {{movimento.descricao}}
                      </h6>
                      <p
                        class="text-secondary font-weight-bold text-xs mt-1 mb-0"
                      >
                      {{fDateReduzida(movimento.data_inicio)}}
                      </p>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div class=" body_print col-lg-9 col-md-9 col-12">
                <h6 class="mb-3">Items</h6>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-12" v-for="item in pedido.items" >
                    <div class="row">
                      <div class="col-lg-2 col-md-2 col-2">
                        
                          <h6 class="text-lg ">{{item.quantidade}}x</h6>

                      </div>
                      <div class="col-6">
                          <h6 class="text-lg ">{{item.descricao_item}}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="horizontal dark mt-4 mb-4" />

            <div class="row">
              
              <div class="col-lg-5 col-md-6 col-12">
                <h6 class="mb-3">Pagamento</h6>
                <div
                  class="card card-body border card-plain border-radius-lg d-flex align-items-center flex-row"
                >
        
                  <h6 class="mb-0">
                    {{ pedido.pagamento_status=='paid' ? 'PAGO':'NÃO PAGO' }}<br>
                    {{ pedido.status_pagamento_gateway=='CONFIRMADO' ? 'GETNET':'PAGA NA ENTREGA' }}
                  </h6>
               
                </div>
              </div>
              <div class="col-lg-5 col-md-6 col-12">
                <h6 class="mb-3 mt-4">Informações de Entrega</h6>
                <ul class="list-group">
                  <li
                    class="list-group-item border-0 d-flex p-4 mb-2 bg-gray-100 border-radius-lg"
                  >
                    <div class="d-flex flex-column">
                      <h6 class="mb-3 text-sm">{{pedido.nome_cliente}}</h6>
                      <span class="mb-2 text-xs">
                        Telefone:
                        <span class="text-dark font-weight-bold ms-2">{{pedido.telefone_cliente}}</span
                        >
                      </span>
                      <span class="mb-2 text-xs">
                        Endereço:
                        <span class="text-dark ms-2 font-weight-bold">
                          {{pedido.endereco1_cliente}} {{pedido.endereco2_cliente}} {{pedido.numero_cliente}}, {{pedido.bairro_cliente}} - {{pedido.cidade_cliente}}/{{pedido.estado_cliente}}

                        </span
                        >
                      </span>
                    </div>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import GoogleMapsApiLoader from 'google-maps-api-loader'

import { defineComponent, ref } from 'vue';

import moment from 'moment';

import PedidosTable from "./components/PedidosTable.vue";
import ProjectsTable from "./components/ProjectsTable.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";

import Loading from "./components/Loading.vue";

import fintailapi from "../api";

const { v4: uuidv4 } = require('uuid');

import { useToast } from "vue-toastification";

export default defineComponent({
  name: "tables",
  components: {
    PedidosTable,
    ProjectsTable,
    ArgonButton,
    ArgonBadge,
    Loading
  },
  data() {
    return {
      map: null,
      google: null,
      data_sincroniza: {data_inicial:"", data_final:""},
      sincronizar: { show:false, progress:0 },
      id : 0,
      pedido: {eventos:[]},
      current_page:0,
      total_pages:0,
      isLoading:true,
      showMapa:true,
      toast : useToast()
    };
  },
  async mounted() {
    
    moment.locale("pt-br");
     /* 
      const googleMapApi = await GoogleMapsApiLoader({
        apiKey: "AIzaSyDrbKpz_7nbJey3xOS5rOXqpcyWBYI7ry0"
      })
      this.google = googleMapApi
      this.initializeMap()
    */

  },
  computed: {

    getMovimentacoes(){

        let movimento = []


        /*
<div class="timeline-block mb-3">
                    <span class="timeline-step">
                      <i class="ni ni-html5 text-secondary"></i>
                    </span>
                    <div class="timeline-content">
                      <h6 class="text-dark text-sm font-weight-bold mb-0">
                        Generate order id #1832412
                      </h6>
                      <p
                        class="text-secondary font-weight-bold text-xs mt-1 mb-0"
                      >
                        22 DEC 7:21 AM
                      </p>
                    </div>
                  </div>
                  <div class="timeline-block mb-3">
                    <span class="timeline-step">
                      <i class="ni ni-cart text-secondary"></i>
                    </span>
                    <div class="timeline-content">
                      <h6 class="text-dark text-sm font-weight-bold mb-0">
                        Order transmited to courier
                      </h6>
                      <p
                        class="text-secondary font-weight-bold text-xs mt-1 mb-0"
                      >
                        22 DEC 8:10 AM
                      </p>
                    </div>
                  </div>
                  <div class="timeline-block mb-3">
                    <span class="timeline-step">
                      <i
                        class="ni ni-check-bold text-success text-gradient"
                      ></i>
                    </span>
                    <div class="timeline-content">
                      <h6 class="text-dark text-sm font-weight-bold mb-0">
                        Order delivered
                      </h6>
                      <p
                        class="text-secondary font-weight-bold text-xs mt-1 mb-0"
                      >
                        22 DEC 4:54 PM
                      </p>
                    </div>
                  </div>
        */
        this.pedido.eventos.forEach(evento => {

          evento.icone = evento.controle=='1'?'ni ni-bell-55':'ni ni-bold-right'

          if(evento.status_entrega==10) evento.icone = 'ni ni-check-bold text-success text-gradient'

          return evento
        })

        movimento.push({
          "descricao":"Pedido Recebido",
          "icone":'ni ni-bell-55',
          "data_inicio": this.pedido.data_criacao,
        })

        movimento.push({
          "descricao":"Em Separação",
          "icone":'ni ni-basket',
          "data_inicio": this.pedido.horario_inicio_separacao,
        })

        movimento.push({
          "descricao":"Fim Separação",
          "icone":'ni ni-box-2',
          "data_inicio": this.pedido.horario_fim_separacao,
        })


      if(this.pedido.data_rota_inicio){
        movimento.push({
          "descricao":"Criação Rota",
          "icone":'ni ni-compass-04',
          "data_inicio": this.pedido.data_rota_inicio,
        })
      }
      
      movimento.push(...this.pedido.eventos);
        

        return movimento
      },
    },
  methods: {

    imprimirPagina() {

      window.print();
      
    },
    hideMapa() {
      this.showMapa = !this.showMapa
    },
    
    initializeMap() {

      const mapContainer = this.$refs.googleMap

      this.map = new this.google.maps.Map(
        mapContainer, {   
            clickableIcons: false,
            streetViewControl: false,
            panControlOptions: false,
            gestureHandling: "cooperative",
            mapTypeControl: true,
            styles: [
                        {
                            "featureType": "administrative",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "poi",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "on" }]
                        },
                        {
                            "featureType": "transit",
                            "stylers": [{ "visibility": "off" }]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels",
                            "stylers": [{ "visibility": "off" }]
                        }
                    ],
                
            zoomControlOptions: {
              style: "SMALL"
            },
            zoom: 13,
            minZoom: 8,
            maxZoom: 20,
            center: { lat: -22.2941067, lng: -48.5642125 }
        }
      )



      var marker = new this.google.maps.Marker({
        position: { lat: -22.2941067, lng: -48.5642125 },
        map:  this.map,
        title: "Centro",
        icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png' // Ícone do marcador
      });

      this.getPedido()

    },
    fDateReduzida(date) {
      //22 DEC 7:20 AM
      return moment(date).format('DD MMM HH:mm:ss').toUpperCase();;
    },
    fDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    doUpdate(event, pedido) {

        this.sincronizar.show = true
        this.sincronizar.progress = 25

        fintailapi
        .put(`/pedidos/${pedido.id_pedido}`,  pedido)
        .then((response) => {
            this.sincronizar.progress = 100
            this.sincronizar.show = false
        })
        .catch((error) => {
          this.sincronizar.show = false
          this.sincronizar.error = error.message
        })


    },
    doAddTag(pedido, codigo_embalagem) {


      this.sincronizar.show = true
      this.sincronizar.progress = 20
      pedido.codigo_embalagem = codigo_embalagem

       pedido.error = null

      fintailapi
      .post(`/pedidos/embalagem/${pedido.id_pedido}`,  pedido)
      .then((response) => {
        
          this.sincronizar.progress = 100
          this.sincronizar.show = false
          
      })
      .catch((error) => {

        pedido.error = "Unidade de Transporte "+codigo_embalagem+" não cadastrada."

        pedido.embalagens.pop();

        this.sincronizar.show = false
        this.sincronizar.error = error.message

      })


    },

    doRemoveTag(pedido, id_embalagem) {

      this.sincronizar.show = true
      this.sincronizar.progress = 20


      fintailapi
      .delete(`/pedidos/embalagem/${pedido.id_pedido}/${id_embalagem}`)
      .then((response) => {

          this.sincronizar.progress = 100
          this.sincronizar.show = false

          this.getPedidos(0)

      })
      .catch((error) => {
        this.sincronizar.show = false
        this.sincronizar.error = error.message
      })


    },
    doCheckSync() {
      fintailapi
        .get(`/pedidos/check/${this.data_sincroniza.uuid}`)
        .then((response) => {
          this.sincronizar.progress = response.data.progresso;
          if (response.data && response.data.status === 'completo') {
            this.sincronizar.success = true;
            this.sincronizar.show = false;
          } else {
            setTimeout(() => {
              this.doCheckSync();
            }, 5000); // Verifica novamente após 5 segundos
          }
        })
        .catch((error) => {
          this.sincronizar.show = false;
          this.sincronizar.error = error.message;
        });
    },
    getPedido() {

        this.isLoading = true
        
        fintailapi
        .get(`/pedidos/${this.id}`)
        .then((response) => {

          this.isLoading = false
          this.pedido    = response.data;

        })
        .catch((error) => {

        })

    },
    searchCall(campo, termo) {

      fintailapi
        .get(`/pedidos/pesquisar/campo?term=${termo}&field=${campo}`)
        .then((response) => {
          this.current_offset = 0;
          this.current_page = 0 / 10; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / 10);
          this.pedidos = response.data.rows;
        })
        .catch((error) => {
          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
        })

    },
   },
   created() {

      this.id = this.$route.params.id || '0';

      this.getPedido()

    },

});


</script>
